import { SecondaryButton, LabelBody, Spacer, Exercise } from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { ExerciseStatus } from '../../interfaces';
import { IllustrationJonas } from '../../icons';

export const exerciseData91: ExerciseData = {
    ExerciseView: IntroModuleJonasArticle,
    dataKeys: [],
    questions: [],
};

function IntroModuleJonasArticle({ onContinue }: ExerciseViewProps) {
    return (
        <>
            <Exercise title="Velkommen til dit forløb">
                <IllustrationJonas className="mx-auto mt-40" />

                <LabelBody class="mt-10">
                    Du er her, fordi du føler dig stresset af noget. Det kan
                    være du har været presset i længere tid eller du er blevet
                    ramt lige pludselig, enten på arbejdet eller i det private.
                </LabelBody>

                <LabelBody class="mt-10">
                    Lige om lidt skal du se en video, der beskriver, hvordan man
                    kan forstå stress. Det her forløb kræver tid og tålmodighed.
                    Det indebærer, at du eksperimenterer med øvelser og metoder
                    i din hverdag. Prøv øvelserne af for at se, hvilke der
                    virker for dig.{' '}
                </LabelBody>

                <LabelBody class="mt-10">
                    Nogle af øvelserne er konkrete værktøjer du kan bruge med
                    det samme. Andre skal du øve dig lidt på, før du mærker en
                    effekt.
                </LabelBody>

                <LabelBody class="mt-10">
                    Forløbet er opdelt i fire moduler. Vi låser et nyt modul op,
                    cirka halvanden uge efter du afslutter et modul. Det gør vi
                    for at give dig tid til at øve i din egen hverdag.
                </LabelBody>
                <LabelBody class="mt-10">
                    Vi håber, at du får gavn af forløbet.
                </LabelBody>
                <LabelBody class="mt-20">
                    Med venlig hilsen,
                    <br />
                    Jonas - Psykolog hos Falck
                </LabelBody>

                <Spacer />

                <SecondaryButton
                    class="mt-30"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: false,
                        })
                    }
                >
                    Tilbage til intromodulet
                </SecondaryButton>
            </Exercise>
        </>
    );
}
